import { IconRemove } from "@/snippets/index.js";
import { Image } from "@/snippets/components/Image";
import { useCartRemoveItems, useCountry } from '@backpackjs/storefront';
import { formatMoney } from "@/utils/Helper";

export default function CartBundleItem({ item }) {
  const { cartRemoveItems } = useCartRemoveItems();
  const discountValue = item.attributes.find(
    (attribute) => attribute.key === '_discount'
  ).value;
  const { country } = useCountry();
  const currencySimbol = country?.currency.symbol || '$';

  const removeBundle = async () => {
    const lineItemsId = item.bundleItems.map((bundleItem) => bundleItem.id);

    await cartRemoveItems({ lineIds: lineItemsId });
  }

  const buildBundleItems = () => {
    const bundleItems = item.bundleItems.map((bundleItem) => {
      return (
        <div
          key={bundleItem.id}
          className="cart-bundle-item__product flex items-center"
        >
          <div className="cart-bundle-item__product-image w-[90px] shrink-0">
            <Image
              src={bundleItem.variant.image.src}
              alt={bundleItem.variant.image.altText}
              width={90}
              height={90}
              sizes="10vw"
            />
          </div>
          <div className="cart-bundle-item__product-details pl-5">
            <div className="cart-bundle-item__product-title font-hafferBold text-xs">
              {bundleItem.variant.product.title}
            </div>
          </div>
        </div>
      );
    });

    return bundleItems;
  }

  const bundleFullPrice = item.bundleItems.reduce((acc, bundleItem) => {
    return (
      acc + Number.parseFloat(bundleItem.estimatedCost.subtotalAmount.amount)
    );
  }, 0);

  const bundleDiscountedPrice = item.bundleItems.reduce((acc, bundleItem) => {
    return acc + Number.parseFloat(bundleItem.estimatedCost.totalAmount.amount);
  }, 0);

  return (
    <div className="cart-items-container border-b border-grey-4 py-6 px-4 lg:py-7 lg:px-0">
      <div className="cart-item__bundle flex flex-wrap px-4 py-6 lg:py-7 lg:px-0">
        <div className="cart-bundle-item__header relative w-full pr-8 pb-4 font-hafferBold text-sm lg:pr-0">
          Bundled Items
          <span className="relative top-[-1px] ml-1 inline-block rounded-sm border border-solid border-primary-2 px-1 font-hafferBold text-sub-xx-small text-primary-2">
            {discountValue}% off
          </span>
          <button
            type="button"
            onClick={removeBundle}
            className="absolute top-0 right-0 lg:hidden"
          >
            <IconRemove />
          </button>
        </div>
        <div className="cart-bundle-item__body flex">
          <div className="cart-bundle-item__products grid grid-cols-1 gap-x-2 gap-y-5 lg:grid-cols-2">
            {buildBundleItems()}
          </div>
          <div className="cart-bundle-item__details hidden flex-shrink-0 items-center text-center lg:block lg:flex">
            <div className="cart-bundle-item__count w-28">
              <span className="mx-auto inline-block border border-grey-4 py-2 px-4 text-center">
                1
              </span>
            </div>
            <div className="cart-bundle-item__price w-28">
              {bundleFullPrice > bundleDiscountedPrice && (
                <s className="cart-bundle-item__full-price font-hafferBold text-sm text-grey-3">
                  {formatMoney(bundleFullPrice.toFixed(2)).replace('$', currencySimbol)}
                </s>
              )}
              <div className="cart-bundle-item__discounted-price font-hafferBold text-sm">
                {formatMoney(bundleDiscountedPrice.toFixed(2)).replace(
                  '$',
                  currencySimbol
                )}
              </div>
            </div>
            <div className="cart-bundle-item__remove w-20 leading-none">
              <button type="button" onClick={removeBundle}>
                <IconRemove />
              </button>
            </div>
          </div>
        </div>
        <div className="cart-bundle-item__footer-body flex w-full lg:hidden">
          <div className="cart-bundle-item__details flex w-full flex-shrink-0 items-center pl-[110px]">
            <div className="cart-bundle-item__count w-28">
              <span className="mx-auto inline-block border border-grey-4 py-2 px-4 text-center">
                1
              </span>
            </div>
            <div className="cart-bundle-item__price flex w-full flex-wrap justify-end gap-2">
              {bundleFullPrice > bundleDiscountedPrice && (
                <s className="cart-bundle-item__full-price font-hafferBold text-sm text-grey-3">
                  {formatMoney(bundleFullPrice.toFixed(2)).replace('$', currencySimbol)}
                </s>
              )}
              <div className="cart-bundle-item__discounted-price inline-block font-hafferBold text-sm">
                {formatMoney(bundleDiscountedPrice.toFixed(2)).replace(
                  '$',
                  currencySimbol
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}